import { Grid2 as Grid, Stack, Typography } from '@mui/material'

type StoreHeaderProps = {
  name: string
  address1: string
  city: string
  state: string
  postalCode: string
  singleRow?: boolean
  noZip?: boolean
}

export const StoreHeader: React.FC<StoreHeaderProps> = props => {
  const {
    name,
    address1,
    city,
    state,
    postalCode,
    singleRow = false,
    noZip = false,
  } = props
  const cityStateZip = `${city}, ${state}${noZip ? '' : ` - ${postalCode}`}`
  return singleRow ? (
    <Stack direction={'row'} spacing={1} alignItems={'center'}>
      <Typography variant="subtitle1">{name}</Typography>
      <Typography>{`${address1} ${cityStateZip}`}</Typography>
    </Stack>
  ) : (
    <Grid container direction={'column'}>
      <Typography variant="subtitle1">{name}</Typography>
      <Typography>{address1}</Typography>
      <Typography>{cityStateZip}</Typography>
    </Grid>
  )
}
